<template>
  <div class="contenido">
    <v-card class="elevation-6" style="opacity:0.8;">
      <v-card-text>
        <v-layout row wrap class="my-2">
          <v-tooltip color="primary" top>
            <template v-slot:activator='{ on }'>
              <v-icon v-on='on' color="primary" x-large @click="$root.$emit('onOpcionPortal', 'principal')">keyboard_backspace</v-icon>
            </template>
            <span>Ir atrás</span>
          </v-tooltip>
          <v-spacer/>
          <span class="primary--text">
            <h3><v-icon class="my-1" color="primary">info</v-icon>&nbsp;Información</h3>
          </span>
          <v-spacer/>
        </v-layout>
        <v-layout row wrap>
          <span class="primary--text">
            <v-icon color="primary">info</v-icon>&nbsp;RECUERDE
          </span>
          <br>
          <br>
          <p align='justify'>
            <b>Plazos para la Presentación de la Declaración Jurada de Bienes y Rentas:</b><br> Debe ser presentada por las Servidoras y Servidores Públicos según corresponda, antes (hasta el primer día hábil del ejercicio del Cargo), durante (en el mes de su nacimiento si reside en capitales de departamento, y si reside fuera de las capitales de departamento, contarán adicionalmente con el mes siguiente de su nacimiento) y después; del ejercicio del cargo (hasta 30 días calendario computables desde el primer día de su desvinculación). Según DECRETO SUPREMO 1233 CAPÍTULO I, ARTÍCULO 4.- (Presentación de la Declaración). 
          </p>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="black--text">
              ¿Necesita más ayuda?
            </span><br><br>
            <span class="black--text">
              <a @click="descargarArchivoPdf(2)">Descargue la guía para realizar la Declaración Jurada de Bienes y Rentas&nbsp;<v-icon>get_app</v-icon></a>
            </span><br>
            <span class="black--text">
              <a href="https://www.youtube.com/watch?v=rp_zEghwT8Q" target="_blank">Siga los pasos del Video Tutorial para realizar la Declaración Jurada de Bienes y Rentas Digital</a>
            </span><br>
            <span class="black--text">
              <a @click="descargarArchivoPdf(3)">Descargue la cartilla Declaración Jurada de Bienes y Rentas&nbsp;<v-icon>get_app</v-icon></a>
            </span><br>
            <span class="black--text">
              <a @click="descargarArchivoPdf(0)">Descargue el manual de usuario para la Declaración Jurada de Bienes y Rentas Tradicional.&nbsp;<v-icon>get_app</v-icon></a>
            </span><br>
            <span class="black--text">
              <a href="https://cloud.contraloria.gob.bo/nextcloud/index.php/s/i6JG4AAMZX7AFNT" target="_blank">Descargue el manual de usuario para la Declaración Jurada de Bienes y Rentas Digital.&nbsp;<v-icon>get_app</v-icon></a>
            </span>
          </v-flex>
        </v-layout>
        <br><br>
          <span class="primary--text">
            <v-icon color="primary">settings_phone</v-icon>&nbsp;&nbsp;TELÉFONOS DE CONSULTAS
          </span>
          <br>
          <br>
          <p>Puede efectuar cualquier consulta y/o solicitud vía mensajes de texto, imagen o mensaje de voz por whatsapp a los siguientes teléfonos: </p>
          <div id=tabla1>
            <div id=cabtab1>
              <v-icon>edit</v-icon>&nbsp;&nbsp;Whatsapp
            </div>
            <div id=cuerpotab1>
              <table>
                <tr>
                <td>BAJAS Y/O EXCLUSIONES :</td>  
                <td>60512947</td>  
                </tr>
                <tr>
                <td>CERTIFICADOS DE SOLVENCIA FISCAL :</td>  
                <td>62462052</td>   
                </tr>
                <tr>
                <td>REGISTRO DE PROCESOS Y CONTRATOS :</td>  
                <td>62414400</td>   
                </tr>
                <tr>
                <td>DECLARACIÓN JURADA DE BIENES Y RENTAS :</td>  
                <td>62415396</td>   
                </tr>
              </table>
            </div>
          </div>
          <p class="mt-2">También puede llamar al teléfono 2177400: </p>
          <div id=tabla1>
            <div id=cabtab1>
              <v-icon>call</v-icon>&nbsp;&nbsp;Internos
            </div>
            <div id=cuerpotab1>
              <table>
                <tr>
                <td>BAJAS Y/O EXCLUSIONES :</td>  
                <td>Int. 550</td>  
                </tr>
                <tr>
                <td>CERTIFICADOS DE SOLVENCIA FISCAL :</td>  
                <td>Int. 514 - 519</td>   
                </tr>
                <tr>
                <td>REGISTRO DE PROCESOS Y CONTRATOS :</td>  
                <td>Int. 514 - 519</td>   
                </tr>
                <tr>
                <td>DECLARACIÓN JURADA DE BIENES Y RENTAS :</td>  
                <td>Int. 607-770-716</td>   
                </tr>
              </table>
            </div>
          </div>
        <br><br><br><br><br><br>
      </v-card-text>    
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'ayuda',
  data () {
    return {};
  },
  methods: {
    descargarArchivoPdf (dato) {
      let urlArchivo = '';
      let usuario = 'portal';
      let nombreUsuario = 'usuario_portal';
      switch (dato) {
        case 0: urlArchivo = 'archivo_predefinido/manual_djbrd_tradicional_externo';
          break;
        case 1: urlArchivo = 'archivo_predefinido/manual_djbrd_digital_externo';
          break;
        case 2: urlArchivo = 'archivo_predefinido/guia_registro_djbr';
          break;
        case 3: urlArchivo = 'archivo_predefinido/cartilla_djbr';
          break;
      }
      this.$service.get(`${urlArchivo}/${usuario}/${nombreUsuario}`).then(response => {
        if (response) {
          this.downloadPDF(response.documento, response.nombre);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    downloadPDF (pdf, name) {
      const url = window.URL.createObjectURL(this.b64toBlob(pdf, 'application/pdf'));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}`);
      document.body.appendChild(link);
      link.click();
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }
  }
};
</script>
<style scoped>
.contenido {
  padding-right: 10%;
  padding-top: 2%;
  padding-left: 10%;
}
#tabla1{
   border: 1px solid #98d1fd;
   width: 600px;
}
#cabtab1{
   background-color: #98d1fd;
   font-weight: bold;
   color: #ffffff;
   padding: 2 2 2 2px;
}
#cuerpotab1{
   padding: 4 4 4 4px;
   background-color: #ecece5;
} 
</style>


// WEBPACK FOOTER //
// src/components/djbrd/Informacion.vue